import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { menuItems } from "../Constant";

const isAllowed = (ComponentToBeRendered) => {
	const Check = (props) => {
		const { pathname } = useLocation();
		const navigate = useNavigate();
		const { userData } = useSelector((state) => state.auth);

		const filteredItem = menuItems.find((menuItem) => {
			return (
				menuItem.path.startsWith(`${pathname}`) ||
				menuItem.path.startsWith(`/${pathname.split("/")?.[1]}`)
			);
		});

		const allowed = filteredItem?.visibleTo?.some((role) => {
			return userData?.role?.includes(role);
		});

		useEffect(() => {
			if (!allowed) {
				const allowedRoutes = menuItems.filter((item) => {
					return item?.visibleTo?.some((role) => {
						return userData?.role?.includes(role);
					});
				});

				if (allowedRoutes.length > 0) {
					navigate(`${allowedRoutes?.[0]?.path}`);
				}
			}
		}, [allowed, navigate, userData?.role]);

		return allowed ? <ComponentToBeRendered {...props} /> : null;
	};
	return Check;
};

export default isAllowed;
